import { create } from "zustand";

export const useB2BStore = create((set) => ({
  data: {},
  setData: (newData) => set({ data: newData })
}));
